import { shape, string } from 'prop-types';
import React from 'react';

import { approval, changelog, comments } from '../../generic/ScopedDrawer';
import ScopedDrawer from '../../generic/ScopedDrawer/ScopedDrawer';
import withQuoteData from '../../quote-editor/with-quote-data';
import Project from '../Project';
import ProjectCampaign from '../ProjectCampaign';
import ProjectHeader from '../ProjectHeader';
import ProjectInvoice from '../ProjectInvoice';
import ProjectOpportunity from '../ProjectOpportunity';
import ProjectQuote from '../ProjectQuote';

const ProjectQuoteForm = withQuoteData(ProjectQuote);
class ProjectLoader extends React.Component {
  shouldComponentUpdate(nextProps) {
    // Routes get updated when the guard is changed.
    // This causes the component tree to rerender
    // and hence the components down the chain are reloaded.
    return (
      this.props.match.params.opportunityId !==
      nextProps.match.params.opportunityId
    );
  }

  render() {
    const { match } = this.props;
    const { opportunityId } = match.params;
    const context = {
      contentType: 'opportunity',
      objectId: opportunityId,
    };

    return (
      <ScopedDrawer
        options={[comments(context), approval(context), changelog(context)]}
      >
        <Project
          entities={[
            {
              id: 1,
              Content: props => (
                <ProjectHeader
                  opportunityId={opportunityId}
                  entityProps={props}
                />
              ),
              isExpanded: true,
            },
            {
              id: 2,
              Content: props => (
                <ProjectOpportunity
                  opportunityId={opportunityId}
                  entityProps={props}
                />
              ),
            },
            {
              id: 3,
              Content: props => (
                <ProjectQuoteForm
                  opportunityId={opportunityId}
                  entityProps={props}
                />
              ),
            },
            {
              id: 4,
              Content: props => (
                <ProjectCampaign
                  opportunityId={opportunityId}
                  entityProps={props}
                />
              ),
            },
            {
              id: 5,
              Content: props => (
                <ProjectInvoice
                  opportunityId={opportunityId}
                  entityProps={props}
                />
              ),
            },
          ]}
        />
      </ScopedDrawer>
    );
  }
}

ProjectLoader.propTypes = {
  match: shape({
    params: shape({ opportunityId: string.isRequired }).isRequired,
  }).isRequired,
};

export default ProjectLoader;
